function ready(fn) {
	if (document.readyState != 'loading'){
		fn();
	} else {
		document.addEventListener('DOMContentLoaded', fn);
	}
}

const randomBetween = (low, high) => Math.floor(Math.random() * (high - low + 1)) + low;

const toggleHeaderClass = () => {
	if(!document.querySelector('header').classList.contains('is-static')) {
		document.querySelector('header').classList.toggle('is-extended', window.scrollY > 100);
	}
}

const doesIntersect = (x, el) => {
	return (x > el.offsetLeft - 30 && x < el.offsetLeft + el.offsetWidth + 30);
}

const createGubbins = (gubbinStore) => {
	const contentArea = gubbinStore.parentNode.querySelector('.container');

	/* Reset state */
	gubbinStore.innerHTML = '';
	let gubbins = [];
	let row = 1;
	let col = 1;
	let counter = 0;

	while(true) {
		/* Calculate grid location */
		const left = col * 120 - 75;
		const top = row * 120 - 95 + (col % 2 == 0 ? 50 : 0);

		/* If we're off screen, stop */
		if(left > gubbinStore.offsetWidth)
			break;

		const gubbinContainer = document.createElement('div');
		const gubbin = document.createElement('div');
		gubbinContainer.appendChild(gubbin);

		if(!doesIntersect(left, contentArea)) {
			/* Position on grid */
			gubbinContainer.style.left = `${left}px`;
			gubbinContainer.style.top = `${top}px`;
			
			/* Randomise */
			const y = randomBetween(-30, 5);
			const x = randomBetween(-15, 20);
			const scale = randomBetween(80, 120) / 100;
			const rotate = randomBetween(-180, 180);
			gubbin.style.transform = `translate(${y}px, ${x}px) scale(${scale}) rotate(${rotate}deg)`;

			/* Select a random image */
			const image = randomBetween(1, 7);
			gubbin.style.backgroundImage = `url('/images/gubbins${image}.svg?v=2')`;

			/* Stagger visibility */
			gubbinContainer.style.animationDelay = `${counter * 50}ms`;
	
			/* Stage it (random chance to die) */
			if(randomBetween(1, 100) > 6) {
				gubbinStore.appendChild(gubbinContainer);
				gubbins.push(gubbin);
				counter++;
			}
		}

		row++;

		/* If we've reached the end of the column, move onto the next one */
		if(top > gubbinStore.offsetHeight - 80) {
			col++;
			row = 1;
			counter = counter - 1;
		}
	}

	gubbinStore.classList.add('has-gubbins');
}

ready(function() {

	/* Get each divider edge SVG and draw the graphic */
	let svgs = document.querySelectorAll(".divider-edge");

	Array.prototype.forEach.call(svgs, function(el, i){
		el.setAttribute('viewBox', '0 0 600 50');
		el.setAttribute('preserveAspectRatio', 'none');
	
		/* Create polygon */
		let polygon = document.createElementNS("http://www.w3.org/2000/svg", "polygon");
		el.appendChild(polygon);
	
		/* Randomise polygon */
		let arr = [
			[ 0,   randomBetween(0, 50) ],
			[ 100, randomBetween(0, 50) ],
			[ 200, el.classList.contains('has-sharp-centre') ? randomBetween(30, 50) : randomBetween(0, 50) ],
			[ 300, el.classList.contains('has-sharp-centre') ? randomBetween(5, 10) : randomBetween(0, 50) ],
			[ 400, el.classList.contains('has-sharp-centre') ? randomBetween(30, 50) : randomBetween(0, 50) ],
			[ 500, randomBetween(0, 50) ],
			[ 600, randomBetween(0, 50) ],
			[ 600, 50 ],
			[ 0,   50 ]
		];
	
		/* Draw all points */
		for (const value of arr) {
			var point = el.createSVGPoint();
			point.x = value[0];
			point.y = value[1];
			polygon.points.appendItem(point);
		}
	});


	/* Listen for scrolls to toggle header */
	window.addEventListener('scroll', toggleHeaderClass);
	toggleHeaderClass();


	/* Create gubbins once gubbin bin is visible */
	let observer = new IntersectionObserver(entries => {
		console.log(entries);
		entries.forEach(entry => {
			if (entry.isIntersecting && !entry.target.classList.contains('has-gubbins')) {
				createGubbins(entry.target);
			}
		});
	}, {
		root: null,
		rootMargin: '0px 0px -50px', 
		threshold: 1
	});

	document.querySelectorAll('.gubbins').forEach(section => {
		observer.observe(section);
	});

	/* If the screen is resized, re-gubbinise */
	window.addEventListener('resize', function(){
		document.querySelectorAll('.gubbins').forEach(section => {
			section.classList.remove('has-gubbins');
			section.innerHTML = '';
			observer.unobserve(section);
			observer.observe(section);
		});
	});

	/* Create hero gubbins immediately */
	const gubbinsHero = document.querySelector('.hero .gubbins')
	
	if(gubbinsHero) {
		createGubbins(document.querySelector('.hero .gubbins'));
	}

});

